var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gallery-item", class: [_vm.rootClasses] },
    [
      _c("cmp-tinted-image", {
        attrs: { facet: "gallery-image", "is-inert": false, img: _vm.preview },
        on: {
          "request-action": function($event) {
            _vm.onGalleryRequested("image")
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b612915", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b612915","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/gallery-image/index.vue
// module id = 295
// module chunks = 5